















































































































































































































































































import Vue, { PropType } from "vue";

import smartphoneIcon from "../../assets/ApplicationPlan/smartphone.svg";
import allDeviceIcon from "../../assets/ApplicationPlan/premium.svg";

import {
  GetChangeDetailRequest,
  GetChangeDetailResponse
} from "@/containers/changePlans/api";

import TextConverter from "@/lib/textConverter";
import Locale from "@/lib/locale";

export interface ChangePlansProps {
  action: string;
  clipStudioPaintDownloadLink: string;
  contractNumber: string;
  currentContractData: any;
  deviceChoice: any;
  defaultData: any;
  deviceType: string;
  deviceUseRangeUrl: string;
  gradeChoice: any;
  gradeDifferenceUrl: string;
  galaxyHelpUrl: string;
  getChangeDetail: any;
  isDiscountContract: boolean;
  lang: any;
  planName: any;
  prevUrl: string;
  prevPath: string;
  priceMap: any;
  planListUrl: string;
  resultPlansMap: any;
  termChoice: any;
  urlHelpDifferenceAmount: string;
  urlHelpChangeDevice: string;
  urlHelpContinuedPatronage: string;
  urlHelpGalaxy: string;
  urlDifferenceInGrade: string;
  vandleCardUrl: string;
  urlGradeChange: string;
  isPaypalContract: boolean;
  isIce: boolean;
  paymentInformationEditUrl: string;
}

export interface ChangePlansData {
  currencyCode: string;
  deviceType: string;
  gradeType: string;
  monthlyPrice: number;
  termType: string;
  yearlyPrice: number;
  changePlansData: GetChangeDetailResponse;
  isGetChangePlans: boolean;
  locale: string;
}

export default Vue.extend({
  name: "vc-change-plans",
  components: {
    smartphoneIcon: smartphoneIcon,
    allDeviceIcon: allDeviceIcon
  },
  props: {
    action: {
      type: String as PropType<ChangePlansProps["action"]>,
      default: ""
    },
    clipStudioPaintDownloadLink: {
      type: String as PropType<ChangePlansProps["clipStudioPaintDownloadLink"]>,
      default: ""
    },
    contractNumber: {
      type: String as PropType<ChangePlansProps["contractNumber"]>,
      default: ""
    },
    currentContractData: {
      type: Object as PropType<ChangePlansProps["currentContractData"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<ChangePlansProps["defaultData"]>,
      default: () => {}
    },
    deviceChoice: {
      type: Object as PropType<ChangePlansProps["deviceChoice"]>,
      default: () => {}
    },
    deviceUseRangeUrl: {
      type: String as PropType<ChangePlansProps["deviceUseRangeUrl"]>,
      default: ""
    },
    galaxyHelpUrl: {
      type: String as PropType<ChangePlansProps["galaxyHelpUrl"]>,
      default: ""
    },
    gradeChoice: {
      type: Object as PropType<ChangePlansProps["gradeChoice"]>,
      default: () => {}
    },
    gradeDifferenceUrl: {
      type: String as PropType<ChangePlansProps["gradeDifferenceUrl"]>,
      default: ""
    },
    isDiscountContract: {
      type: Boolean as PropType<ChangePlansProps["isDiscountContract"]>,
      default: false
    },
    lang: {
      type: Object as PropType<ChangePlansProps["lang"]>,
      default: () => {}
    },
    planName: {
      type: Object as PropType<ChangePlansProps["planName"]>,
      default: () => {}
    },
    planListUrl: {
      type: String as PropType<ChangePlansProps["planListUrl"]>,
      default: ""
    },
    prevUrl: {
      type: String as PropType<ChangePlansProps["prevUrl"]>,
      default: ""
    },
    prevPath: {
      type: String as PropType<ChangePlansProps["prevPath"]>,
      default: ""
    },
    priceMap: {
      type: Object as PropType<ChangePlansProps["priceMap"]>,
      default: () => {}
    },
    resultPlansMap: {
      type: Object as PropType<ChangePlansProps["resultPlansMap"]>,
      default: () => {}
    },
    termChoice: {
      type: Object as PropType<ChangePlansProps["termChoice"]>,
      default: () => {}
    },
    urlHelpDifferenceAmount: {
      type: String as PropType<ChangePlansProps["urlHelpDifferenceAmount"]>,
      default: ""
    },
    urlHelpChangeDevice: {
      type: String as PropType<ChangePlansProps["urlHelpChangeDevice"]>,
      default: ""
    },
    urlHelpContinuedPatronage: {
      type: String as PropType<ChangePlansProps["urlHelpContinuedPatronage"]>,
      default: ""
    },
    urlHelpGalaxy: {
      type: String as PropType<ChangePlansProps["urlHelpGalaxy"]>,
      default: ""
    },
    urlDifferenceInGrade: {
      type: String as PropType<ChangePlansProps["urlDifferenceInGrade"]>,
      default: ""
    },
    vandleCardUrl: {
      type: String as PropType<ChangePlansProps["vandleCardUrl"]>,
      default: ""
    },
    urlGradeChange: {
      type: String as PropType<ChangePlansProps["urlGradeChange"]>,
      default: ""
    },
    isPaypalContract: {
      type: Boolean as PropType<ChangePlansProps["isPaypalContract"]>,
      default: false
    },
    isIce: {
      type: Boolean as PropType<ChangePlansProps["isIce"]>,
      default: false
    },
    paymentInformationEditUrl: {
      type: String as PropType<ChangePlansProps["paymentInformationEditUrl"]>,
      default: ""
    },
    //actionsToProps
    getChangeDetail: {
      type: Function as PropType<ChangePlansProps["getChangeDetail"]>,
      default: () => {}
    }
  },
  data(): ChangePlansData {
    return {
      deviceType: this.defaultData.deviceType,
      gradeType: this.defaultData.gradeType,
      termType: this.defaultData.termType,
      currencyCode: this.defaultData.currencyCode,
      monthlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.deviceType][
          this.defaultData.gradeType
        ]["month"]
      ][this.defaultData.currencyCode],
      yearlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.deviceType][
          this.defaultData.gradeType
        ]["year"]
      ][this.defaultData.currencyCode],
      changePlansData: {
        currencyCode: "",
        current: {},
        changePlans: [],
        discountPrice: 0,
        discountRemainMonth: 0,
        discountSettlementScheduledTo: 0,
        instantPayment: 0,
        isDiscount: false,
        firstChangePlanType: "",
        isImmediateNoPriceDifference: false,
        regularSettlementScheduledPrice: 0,
        regularSettlementScheduledFrom: 0,
        settlementScheduledPrice: 0,
        settlementScheduledTerm: "",
        settlementScheduledAt: 0
      },
      isGetChangePlans: false,
      locale: Locale.getLocale()
    };
  },
  mounted() {
    this.changePrice();
  },
  methods: {
    submitPlan() {
      const formElement = this.$refs.changeForm as HTMLFormElement;
      if (this.isImmediate) {
        const inputPlan = document.createElement("input");
        inputPlan.setAttribute("type", "hidden");
        inputPlan.setAttribute("name", "instantPayment");
        inputPlan.setAttribute(
          "value",
          String(this.changePlansData.instantPayment)
        );
        formElement.appendChild(inputPlan);
      }
      formElement.submit();
    },
    changePrice() {
      this.monthlyPrice = this.priceMap[
        this.resultPlansMap[this.deviceType][this.gradeType]["month"]
      ][this.currencyCode];
      this.yearlyPrice = this.priceMap[
        this.resultPlansMap[this.deviceType][this.gradeType]["year"]
      ][this.currencyCode];

      // 現状の契約内容と選択項目が同じであれば、契約変更内容の案内は表示しない
      if (!this.isSelectedDifferentFromCurrentContract()) {
        this.isGetChangePlans = false;
        return;
      }

      const requestParams = {
        deviceType: this.deviceType,
        gradeType: this.gradeType,
        termType: this.termType,
        contractNumber: this.contractNumber
      } as GetChangeDetailRequest;

      this.getChangeDetail(requestParams).then((res: any) => {
        this.changePlansData = res.changePlansData as GetChangeDetailResponse;
        this.isGetChangePlans = true;
      });
    },
    replaceBr(text: string) {
      return TextConverter.replaceBr(text);
    },
    getNextButtonColorClass(isEnable: boolean) {
      if (this.isPaypalContract) {
        return "componentCardInfoButton--disabled";
      }

      return isEnable
        ? "componentCardInfoButton"
        : "componentCardInfoButton--disabled";
    },
    isSelectedDifferentFromCurrentContract(): boolean {
      return (
        this.currentContractData.deviceType !== this.deviceType ||
        this.currentContractData.gradeType !== this.gradeType ||
        this.currentContractData.termType !== this.termType
      );
    },
    isSelectedDifferentDeviceType(deviceName: string): boolean {
      return (
        this.currentContractData.deviceType === deviceName &&
        this.currentContractData.deviceType !== this.deviceType
      );
    },
    isSelectedDifferentGradeType(gradeName: string): boolean {
      return (
        this.currentContractData.gradeType === gradeName &&
        this.currentContractData.gradeType !== this.gradeType
      );
    },
    isSelectedDifferentTermType(termName: string): boolean {
      return (
        this.currentContractData.termType === termName &&
        this.currentContractData.termType !== this.termType
      );
    }
  },
  computed: {
    isSelectedPlan(): boolean {
      return (
        this.currentContractData.currentPlanCode !==
        this.resultPlansMap[this.deviceType][this.gradeType][this.termType]
      );
    },
    isSmartPhonePlan(): boolean {
      return this.deviceType === "smartphone";
    },
    isChangeDevice(): boolean {
      return this.currentContractData.deviceType !== this.deviceType;
    },
    isExToPro(): boolean {
      return (
        this.currentContractData.gradeType === "ex" && this.gradeType === "pro"
      );
    },
    isProToEx(): boolean {
      return (
        this.currentContractData.gradeType === "pro" && this.gradeType === "ex"
      );
    },
    isOnlyTermChange(): boolean {
      const isSameDeviceType =
        this.currentContractData.deviceType === this.deviceType;
      const isSameGradeType =
        this.currentContractData.gradeType === this.gradeType;
      const isDifferenceTermType =
        this.currentContractData.termType !== this.termType;
      return isSameDeviceType && isSameGradeType && isDifferenceTermType;
    },
    isImmediate(): boolean {
      return (
        this.changePlansData.firstChangePlanType === "immediate" ||
        this.changePlansData.firstChangePlanType ===
          "immediate_no_price_difference"
      );
    },
    isChangeDeviceRelatedSmartphone(): boolean {
      return (
        (this.currentContractData.deviceType === "smartphone" ||
          this.deviceType === "smartphone") &&
        !(
          this.currentContractData.deviceType === "smartphone" &&
          this.deviceType === "smartphone"
        )
      );
    }
  }
});
